<form (ngSubmit)="onSubmit()" [formGroup]="registerForm">
  <div class="flex flex-column gap-3 mt-2">
    <div class="flex flex-column gap-1">
      <p-iconfield>
        <p-inputicon><i class="pi pi-user"></i></p-inputicon>
        <input
          [invalid]="formValidation.isInvalid('name')"
          autofocus
          fluid
          formControlName="name"
          id="name"
          pInputText
          placeholder="{{ 'app.fields.name' | translate }}"
          type="text"
        />
      </p-iconfield>
      <app-form-error-display [control]="registerForm.get('name')"></app-form-error-display>
    </div>
    <div class="flex flex-column gap-1">
      <p-iconfield>
        <p-inputicon><i class="pi pi-user-edit"></i></p-inputicon>
        <input
          [invalid]="formValidation.isInvalid( 'last_name')"
          fluid
          formControlName="last_name"
          id="last_name"
          pInputText
          placeholder="{{ 'app.fields.last_name' | translate }}"
          type="text"
        />
      </p-iconfield>
      <app-form-error-display [control]="registerForm.get('last_name')"></app-form-error-display>
    </div>
    <div class="flex flex-column gap-1">
      <p-iconfield>
        <p-inputicon><i class="pi pi-envelope"></i></p-inputicon>
        <input
          [invalid]="formValidation.isInvalid( 'email')"
          autofocus
          fluid
          formControlName="email"
          id="email"
          pInputText
          placeholder="{{ 'app.fields.email' | translate }}"
          type="email"
        />
      </p-iconfield>
      <app-form-error-display [control]="registerForm.get('email')"></app-form-error-display>
    </div>
    <div class="flex flex-column gap-1">
      <p-iconfield>
        <p-inputicon><i class="pi pi-lock"></i></p-inputicon>
        <p-password
          [feedback]="false"
          [invalid]="formValidation.isInvalid( 'password')"
          [toggleMask]="true"
          fluid
          formControlName="password"
          id="password"
          placeholder="{{ 'app.fields.password' | translate }}"
        ></p-password>
      </p-iconfield>
      <app-form-error-display [control]="registerForm.get('password')"></app-form-error-display>
    </div>
    <app-button
      class="mt-2"
      [label]="'app.buttons.register' | translate"
      [disabled]="loading"
      [fullWidth]="true"
      [shadow]="false"
      type="submit"
    ></app-button>

    <app-sso-buttons (success)="success.emit()" />
  </div>
</form>
